export default {"src":"/_next/static/media/three-dots.b4ca5493.svg","height":16,"width":4,"blurWidth":0,"blurHeight":0};